import Swal from "sweetalert2";
import { CONFIG } from "./../_config/config";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { idletimeparameters } from "../_models/idle-time-parameters.interface";
import { timer } from "rxjs";

import { DEFAULT_INTERRUPTSOURCES, Idle } from "@ng-idle/core";
import { Keepalive } from "@ng-idle/keepalive";
import { Subscription, Observable, BehaviorSubject } from "rxjs";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class IdleTimeParametersService {
  gateway = this.config.gateway;
  idletime: idletimeparameters = {};
  idleState = "Nó empezado.";
  timedOut = false;
  lastPing?: Date = null;

  modalSuject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  showModal: Observable<boolean> = this.modalSuject.asObservable();

  subscriptionOnIdleEnd: Subscription;
  subscriptionOnTimeout: Subscription;
  subscriptionOnTimeoutWarning: Subscription;
  subscriptionOnPing: Subscription;
  subscriptionIdleTimeParametersService: Subscription;

  constructor(
    private http: HttpClient,
    private idle: Idle,
    private keepalive: Keepalive,
    public router: Router,
    private config: CONFIG
  ) {
    //console.log('Inactividadd:', this.http.get(`${this.gateway.url}/master/inactivity`));
    try {
      // this.http.get(`${this.gateway.url}/master/inactivity`).subscribe(config =>  {this.configIdle(config)});
    } catch (error) {
      console.log("Error");
    }
  }

  configIdle(config) {
    // console.log('-----------', config)
    this.idle.setIdle(config.idle); // establece un tiempo de espera inactivo de 5 minuto, para propósitos de prueba.
    this.idle.setTimeout(config.timeout); // establece un tiempo de espera de 5 minutos. Después de 10 minutos de inactividad, el usuario se considerará agotado.

    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES); // establece las interrupciones predeterminadas, en este caso, cosas como clics, desplazamientos, toques en el documento

    this.subscriptionOnIdleEnd = this.idle.onIdleEnd.subscribe((state) => {
      console.log("1");
      this.idleState = "ACTIVE USER.";
      this.modalSuject.next(false);
      // this.mdStickUp.hide();
    });

    this.subscriptionOnTimeout = this.idle.onTimeout.subscribe(() => {
      console.log("2");
      this.idleState = "DISCONNECTED!";
      this.timedOut = true;
      sessionStorage.clear();
      //window.location.reload(true);
      location.href = "/";
      //this.router.navigateByUrl('/');
    });

    this.subscriptionOnTimeoutWarning = this.idle.onTimeoutWarning.subscribe(
      (countdown) => {
        // this.mdStickUp.show();
        this.modalSuject.next(true);
        console.log("3");
        this.idleState = +countdown + " segundos.";
      }
    );

    // establece  ping a 2 minutos
    this.keepalive.interval(config.interval);

    this.subscriptionOnPing = this.keepalive.onPing.subscribe(
      () => (this.lastPing = new Date())
    );

    this.reset();
  }

  reset() {
    this.idle.watch();
    this.idleState = "START.";
    this.timedOut = false;
  }

  ngOnDestroy() {
    if (this.subscriptionOnIdleEnd) {
      console.log("subscriptionOnIdleEnd");
      this.subscriptionOnIdleEnd.unsubscribe();
    }
    if (this.subscriptionOnTimeout) {
      console.log("subscriptionOnTimeout");
      this.subscriptionOnTimeout.unsubscribe();
    }
    if (this.subscriptionOnTimeoutWarning) {
      console.log("subscriptionOnTimeoutWarning");
      this.subscriptionOnTimeoutWarning.unsubscribe();
    }
    if (this.subscriptionOnPing) {
      console.log("subscriptionOnPing");
      this.subscriptionOnPing.unsubscribe();
    }
    if (this.subscriptionIdleTimeParametersService) {
      console.log("subscriptionIdleTimeParametersService");
      this.subscriptionIdleTimeParametersService.unsubscribe();
    }
  }

  inactiveTimmer(seconds) {
    let contador;
    document.onmousemove = resetTimer;
    document.onkeypress = resetTimer;
    function resetTimer() {
      clearTimeout(contador);
      contador = setTimeout(logout, seconds);
  
    }

    function logout() {
      Swal.fire({
        icon: 'warning',
        title: `Limite de tiempo inactivo. Su session sera cerrada, ¿Desea continuar?`,
        showDenyButton: true,
        confirmButtonText: "Continuar",
        denyButtonText: "Cerrar Sesión",
        confirmButtonColor: "#008bff",
        denyButtonColor: "rgb(24, 128, 56)",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          // Swal.fire("Saved!", "", "success");
             resetTimer();
        } else if (result.isDenied) {
          // Swal.fire("Changes are not saved", "", "info");
          window.location.href = "/";
        }
      });
     
    }
  }
}
